var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkgreyInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.99997 1.35796C3.15964 1.35796 0.857108 3.6605 0.857108 6.50082C0.857108 9.34114 3.15964 11.6437 5.99997 11.6437C8.84029 11.6437 11.1428 9.34114 11.1428 6.50082C11.1428 3.6605 8.84029 1.35796 5.99997 1.35796Z",
    stroke: "#40596B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 339"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.99994 8.73425L5.99994 6.19966",
    stroke: "#40596B",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.99997 4.26855L5.99997 4.00064",
    stroke: "#40596B",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkgreyInfoIcon);
export default __webpack_public_path__ + "static/media/darkgrey-info-icon.e76f2f9992d2f986f38836854f745572.svg";
export { ForwardRef as ReactComponent };